import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['trigger', 'content', 'inverseContent'];

  connect() {
    this.sync();
  }

  sync() {
    if (!this.hasTriggerTarget) return;

    const active = this.triggerTargets.every((trigger) => trigger.checked);

    this.contentTargets.forEach((content) => {
      content.classList.toggle('hidden', !active);
    });

    this.inverseContentTargets.forEach((content) => {
      content.classList.toggle('hidden', active);
    });
  }
}
